import { render } from "./AdminDataContractDetails.vue?vue&type=template&id=d4668c8c&scoped=true"
import script from "./AdminDataContractDetails.vue?vue&type=script&lang=js"
export * from "./AdminDataContractDetails.vue?vue&type=script&lang=js"

import "./AdminDataContractDetails.vue?vue&type=style&index=0&id=d4668c8c&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4668c8c"]])

export default __exports__